import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { ContactGenre, ContactMessageSenderType } from "@/lib/gql/__generated__/graphql";

import { contactUpdateInputZodSchema } from "../../schema";

import type { ContactUpdateInputZodSchemaType } from "../../schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	hotelID: string;
	contactID: string;
};

export const useContactForm = ({
	hotelID,
	contactID,
}: Props): { form: UseFormReturn<ContactUpdateInputZodSchemaType> } => {
	const defaultValues: ContactUpdateInputZodSchemaType = {
		contactGenre: ContactGenre.HostSettings,
		hotelID,
		contactID,
		message: {
			senderType: ContactMessageSenderType.Host,
			message: "",
			relatedURLs: [],
			images: [],
		},
	} satisfies ContactUpdateInputZodSchemaType;

	const form: UseFormReturn<ContactUpdateInputZodSchemaType> = useForm<ContactUpdateInputZodSchemaType>({
		mode: "onChange",
		resolver: zodResolver(contactUpdateInputZodSchema),
		defaultValues,
	});

	// form 全体がメモ化される予定らしいので、`trigger` だけが `useEffect` の依存関係に含まれるようにしている
	// @docs https://react-hook-form.com/docs/useform#:~:text=useForm%20return%20and%20useEffect%20dependencies
	const { trigger } = form;
	useEffect(() => {
		trigger();
	}, [trigger]);

	return { form };
};
